import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-legend',
  templateUrl: './legend.page.html',
  styleUrls: ['./legend.page.scss'],
})
export class LegendPage implements OnInit {

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
  }
  dismiss() {
    this.modalCtrl.dismiss();
  }
}
